import store from "../store/store"
import crypto from 'crypto-js'
import url from '../libs'
import dayjs from 'dayjs'
import config from '../common/config'
/*
* appel de la fonction getupay dans n'impote quel composant
* elle prend deux parametres
* le montant TTC
* et le type de paiement
* ==>
 */
export default function getUpay (montant_ttc, modePaiement)
{
   /*=======On teste pour savoir si le devis pour paiement est bien dans le store==========*/
   if(typeof store.state.devis !=='undefined' && store.state.devis!==null && store.state.user && store.state.user!==null)
   {

    if(montant_ttc && modePaiement)
    {
        
        "use strict";
        /** UPAY ATPS */
        let upayScript = document.createElement('script');
        upayScript.onload = ()=>{
            AmnPy.loadModal()
        };
        
        let accessKey = config.upay.accessKey;
        let private_key = config.upay.private_key;
        let host = url.urlweb;
        let merchantId = config.upay.merchantId;
        let order_id = null;
        order_id = merchantId + '-' + Math.random().toString(16).slice(-7);
        let numeroDevis = store.state.devis.result.devis.numeroDevis;
        let codePartenaire = store.state.devis.result.devis.codep;
        let products_ids = codePartenaire + numeroDevis;
        let description = "Paiement de pack "+store.state.devis.result.branche[0].branche + " No: " +store.state.devis.result.devis.numeroDevis +". Partenaire: "+store.state.devis.result.partenaire.societe;
        let montant = parseInt(montant_ttc) * 100
        let currency = "XOF";
        let client_name = store.state.user.nom;
        let client_phone = store.state.user.telephone_port;
        let client_email = store.state.user.email;
        let expiration_date = dayjs(store.state.devis.result.devis.dateEcheance).format('DD/MM/YYYY');
        let redirect_url = url.urlweb+'payement/succes/';
        let message = merchantId + ':' + order_id + ':' + montant + ':' + currency;
        let hash = crypto.HmacSHA1(message, private_key).toString();
    
        /* on sauvegarde les elements
        * orderid: l'id de de la commande cote upay
        * modepaiement; soit mobile money, carte bancaire etc
        * */
       store.dispatch('setOrderId', order_id);
       store.dispatch('setmodePaiement', modePaiement);
    
        upayScript.type = `text/javascript`;
        upayScript.src = config.upay.upayScript_src;
    
        upayScript.setAttribute('id', 'upay-js');
        upayScript.setAttribute('data-host', host);
        upayScript.setAttribute('data-lang', 'fr');
        upayScript.setAttribute('data-mode', 'js');
        upayScript.setAttribute('data-merchant_id', merchantId);
        upayScript.setAttribute('data-access_key', accessKey);
        upayScript.setAttribute('data-order_id', order_id);
        upayScript.setAttribute('data-order_description', description);
        upayScript.setAttribute('data-products_ids', products_ids);
        upayScript.setAttribute('data-amount', montant);
        upayScript.setAttribute('data-currency', currency);
        upayScript.setAttribute('data-client_name', client_name);
        upayScript.setAttribute('data-client_phone', client_phone);
        upayScript.setAttribute('data-client_email', client_email);
        upayScript.setAttribute('data-expiration_date', expiration_date);
        upayScript.setAttribute('data-hmac', hash);
        upayScript.setAttribute('data-redirect_url', redirect_url);
        
        document.head.append(upayScript)

    }


   }


   if(typeof store.state.devispayementDiffere !=='undefined' && store.state.devispayementDiffere!==null && store.state.user && store.state.user!==null)
   {

    if(montant_ttc && modePaiement)
    {
        
        "use strict";
        /** UPAY ATPS */
        let upayScript = document.createElement('script');
        upayScript.onload = ()=>{
            AmnPy.loadModal()
        };

        let private_key = config.upay.private_key;
        let host = url.urlweb;
        let merchantId = config.upay.merchantId;
        let accessKey = config.upay.accessKey;
        let order_id = null;
        order_id = merchantId + '-' + Math.random().toString(16).slice(-7);
        let numeroDevis = store.state.devispayementDiffere.result.devis.numeroDevis;
        let codePartenaire = store.state.devispayementDiffere.result.devis.codep;
        let products_ids = codePartenaire + numeroDevis;
        let description = "Paiement de pack "+store.state.devispayementDiffere.result.branche[0].branche + " No: " +store.state.devispayementDiffere.result.devis.numeroDevis +". Partenaire: "+store.state.devispayementDiffere.result.partenaire.societe;
        let montant =  parseInt(montant_ttc) * 100
        let currency = "XOF";
        let client_name = store.state.user.nom;
        let client_phone = store.state.user.telephone_port;
        let client_email = store.state.user.email;
        let expiration_date = dayjs(store.state.devispayementDiffere.result.devis.dateEcheance).format('DD/MM/YYYY');
        let redirect_url = url.urlweb+'payement/succes/';
        let message = merchantId + ':' + order_id + ':' + montant + ':' + currency;
        let hash = crypto.HmacSHA1(message, private_key).toString();
    
        /* on sauvegarde les elements
        * orderid: l'id de de la commande cote upay
        * modepaiement; soit mobile money, carte bancaire etc
        * */
       store.dispatch('setOrderId', order_id);
       store.dispatch('setmodePaiement', modePaiement);
    
        upayScript.type = `text/javascript`;
        upayScript.src = config.upay.upayScript_src;
    
        upayScript.setAttribute('id', 'upay-js');
        upayScript.setAttribute('data-host', host);
        upayScript.setAttribute('data-lang', 'fr');
        upayScript.setAttribute('data-mode', 'js');
        upayScript.setAttribute('data-merchant_id', merchantId);
        upayScript.setAttribute('data-access_key', accessKey);
        upayScript.setAttribute('data-order_id', order_id);
        upayScript.setAttribute('data-order_description', description);
        upayScript.setAttribute('data-products_ids', products_ids);
        upayScript.setAttribute('data-amount', montant);
        upayScript.setAttribute('data-currency', currency);
        upayScript.setAttribute('data-client_name', client_name);
        upayScript.setAttribute('data-client_phone', client_phone);
        upayScript.setAttribute('data-client_email', client_email);
        upayScript.setAttribute('data-expiration_date', expiration_date);
        upayScript.setAttribute('data-hmac', hash);
        upayScript.setAttribute('data-redirect_url', redirect_url);
        
        document.head.append(upayScript)

    }


   }
   
}
